import * as React from 'react'

function SvgCleaningIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 8.727h13m-13 0l.712 13.38A2 2 0 003.709 24h9.479L14 8.727m-13 0C1 5.564 3.91 3 7.5 3S14 5.564 14 8.727"
        stroke="currentColor"
        strokeWidth={1.6}
      />
      <path
        d="M4.5 12.444V9h6v3.444m-6 0V14m0-1.556h3m3 0V14m0-1.556h-3m0 0V14M18 1l-1.5 20m0 0h-3.58m3.58 0h4.04a1.5 1.5 0 011.5 1.5v0a1.5 1.5 0 01-1.5 1.5H11"
        stroke="currentColor"
        strokeWidth={1.6}
      />
    </svg>
  )
}

export default SvgCleaningIcon
